<p-table
    stripedRows
    #baseRateTable
    [value]="viewRows"
    sortField="EmployeeName"
    [sortOrder]="1"
    editMode="row"
    (onEditInit)="onEditInit($event)"
    (onRowEditSave)="onRowEditSave($event)"
    dataKey="EmployeeListID"
    styleClass="p-datatable-sm p-datatable-striped"
    [scrollable]="true"
    scrollHeight="55vh"
>
    <ng-template pTemplate="header">
        <tr>
            <th class="edit-cell"></th>
            <th class="status-cell"></th>
            <th pSortableColumn="EmployeeName">
                Employee Name
                <p-sortIcon field="EmployeeName" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order">
                </p-sortIcon>
                <p-columnFilter
                    field="EmployeeListID"
                    matchMode="in"
                    display="menu"
                    [showMatchModes]="false"
                    [showOperator]="false"
                    [showAddButton]="false"
                    class="ml-auto"
                >
                    <ng-template #filter let-value let-filter="filterCallback">
                        <p-multiSelect
                            fluid
                            defaultLabel="Filter"
                            appendTo="body"
                            [options]="employeeSelectItems"
                            [filter]="true"
                            [ngModel]="value"
                            (ngModelChange)="filter($event)"
                        ></p-multiSelect>
                    </ng-template>
                </p-columnFilter>
            </th>
            <th pSortableColumn="EmpRateType">
                Employee Type
                <p-sortIcon field="EmpRateType" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order">
                </p-sortIcon>
            </th>
            <th pSortableColumn="BaseRate">
                Base Rate
                <p-sortIcon field="BaseRate" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order">
                </p-sortIcon>
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rate let-edit="editing">
        <tr [pEditableRow]="rate" data-id="row-{{ rate.EmployeeListID }}">
            <td class="edit-cell" style="text-align: center; vertical-align: middle">
                <div style="display: flex; justify-content: space-around">
                    <button
                        *ngIf="
                            !edit &&
                            (!editing?.EmployeeListID ||
                                editing?.EmployeeListID === rate?.EmployeeListID)
                        "
                        style="height: 2.1rem; width: 2.1rem"
                        pButton
                        type="button"
                        pInitEditableRow
                        icon="pi pi-pencil"
                        class="p-button-rounded p-button-text"
                        title="Edit"
                        (click)="onRowEditInit(rate)"
                    ></button>
                    <button
                        *ngIf="edit"
                        style="height: 2.1rem; width: 2.1rem"
                        pButton
                        type="button"
                        pSaveEditableRow
                        icon="pi pi-check"
                        class="p-button-rounded p-button-text p-button-success"
                        title="Save"
                        (click)="onRowEditSave(rate)"
                    ></button>
                    <button
                        *ngIf="edit"
                        style="height: 2.1rem; width: 2.1rem"
                        pButton
                        type="button"
                        pCancelEditableRow
                        icon="pi pi-times"
                        class="p-button-rounded p-button-text p-button-danger"
                        title="Cancel"
                        (click)="onRowEditCancel(rate)"
                    ></button>
                </div>
            </td>
            <td class="status-cell">
                <ef-status-icon
                    [status]="rate?.Status?.StatusCode"
                    [message]="rate?.Status?.Message"
                ></ef-status-icon>
            </td>
            <td>{{ rate.EmployeeName }}</td>
            <td>{{ rate.EmpRateType }}</td>
            <td>
                <p-cellEditor>
                    <ng-template pTemplate="input">
                        <input pInputText type="text" [(ngModel)]="rate.BaseRate" />
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ rate.BaseRate }}
                    </ng-template>
                </p-cellEditor>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="5" style="text-align: center">No base rate data.</td>
        </tr>
    </ng-template>
</p-table>
